import { GamAdConfiguration } from '@schibsted-nmp/advertising-shared/src/types';

export function initiate(gamAdConfig: GamAdConfiguration) {
  window.googletag = window.googletag || {};
  window.googletag.cmd = window.googletag.cmd || [];

  window.googletag.cmd.push(() => {
    gamAdConfig?.placements?.forEach((placement) => {
      window.googletag
        .defineSlot(
          `/${gamAdConfig.networkId}/${gamAdConfig.adUnitName}/${placement.adUnitId}`,
          placement.sizes,
          placement.placementId
        )
        .addService(window.googletag.pubads());
      placement.targeting.forEach((target) => {
        window.googletag.pubads().setTargeting(target.key, target.value);
      });
      window.googletag.pubads().enableSingleRequest();
      window.googletag.enableServices();
      window.googletag.display(placement.placementId);
    });
  });
}
